<template>
    <v-app>
        <v-main>
            <!--<keep-alive>-->
            <router-view />
            <!--ref="routeBody"-->
            <!--</keep-alive>-->
        </v-main>
    </v-app>
</template>

<script>
//import ShopLogo from "../components/logos/ShopLogo.vue";
//import SureLogo from "../components/logos/SureLogo.vue";

export default {
    name: "SideNavigationLayout",
    created: async function() {
//
    },
     components: {
        //
    },
    computed: {
//
    },
    methods: {
//
    },
    data: () => ({
        //
    })
};
</script>
<style lang="stylus">
</style>